<template>
  <wrap-container>
    <section-label v-if="title" :value="title" />
    <custom-input-group
      :vertical="true"
      :value="model.item"
      @onRadioClick="change"
    >
      <radio-item
        class="radio-item"
        v-for="item in items"
        :key="item.value"
        :optionValue="item.value"
        :label="item.label"
      />
    </custom-input-group>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import SectionLabel from "@/components/core/SectionLabel";
import RadioItem from "@/components/core/custom/RadioItem";
import CustomInputGroup from "@/components/core/custom/CustomInputGroup";
export default {
  components: {
    WrapContainer,
    RadioItem,
    SectionLabel,
    CustomInputGroup
  },
  props: {
    title: {
      type: String,
      default: "Motivo de la consulta"
    }
  },
  data() {
    return {
      model: {
        item: this.$route.meta.levels[2]
      }
    };
  },
  computed: {
    items() {
      let consultas = [];
      let items = this.config.vistas[this.$route.meta.levels[0]].items[
        this.$route.meta.levelsShort[1]
      ].items;
      for (const key in items) {
        // eslint-disable-next-line no-prototype-builtins
        if (items.hasOwnProperty(key)) {
          const element = items[key];
          consultas.push({
            label: element.label,
            value: element.routeName
          });
        }
      }
      return consultas;
    }
  },
  methods: {
    change(ruta) {
      this.model.item = ruta;
      if (ruta && this.$route.name !== ruta) {
        this.$router.push({ name: ruta });
      }
    }
  },
  watch: {
    $route(to) {
      this.model.item = to.meta.levels ? to.meta.levels[1] : null;
    }
  }
};
</script>

<style>
.radio-item {
  margin-bottom: 14px;
}
</style>
